/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useRef, useState, useEffect, useContext } from "react";
import { AgGridReact } from 'ag-grid-react';
import { AppContext } from "../MainComponents/AppContext";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import LoaderGif from "../../images/365 loading.gif";

const PopupModal = props => {
    const divStyle = {
        display: props.displayModal ? "block" : "none",
        zIndex: "10002"
    };
    const gridRef = useRef();
    const [appOrg, setAppOrg] = useContext(AppContext);
    const [columnDefs, setColumnDefs] = useState([]);
    const [gridApi, setGridApi] = useState([]);
    const [populate, setPopulate] = useState(false);
    const rowHeight = 25;
    const headerHeight = 35;
    const getRowStyle = params => {
        return { fontSize: "Small" };
    };

    const defaultColDef = useMemo(() => ({
        sortable: false,
        resizable: true
    }), []);

    function setColumnDefinition() {
        switch (props.itemType) {
            case 'user':
                {
                    let columnDefs = [
                        {
                            field: 'displayName',
                            filter: false,
                            ////filter: 'agTextColumnFilter',
                            ////filterParams: {
                            ////    maxNumConditions: 1,

                            ////    filterOptions: ['contains'],

                            ////    defaultOption: 'contains',
                            ////},



                            headerName: 'Object', width: 350
                        },
                        { field: 'type', filter: false, headerName: 'Type', width: 300 },
                        {
                            field: 'mailbox',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Mailbox" class='mail-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => params.node.setDataValue(params.column.colId, e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                            )
                        },
                        {
                            field: 'archiveMailbox',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Archive Mailbox" class='archivemail-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => params.node.setDataValue(params.column.colId, e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                            )
                        },
                        {
                            field: 'onedrive',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Onedrive" class='onedrive-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => params.node.setDataValue(params.column.colId, e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                            )
                        },
                        {
                            field: 'site',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Sharepoint" class='sharepoint-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => params.node.setDataValue(params.column.colId, e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                            )
                        }
                    ];
                    setColumnDefs(columnDefs);
                    break;
                }
            case 'group':
                {
                    let columnDefs = [
                        { field: 'displayName', filter: false, headerName: 'Object', width: 280 },
                        { field: 'type', filter: false, headerName: 'Type', width: 260 },
                        {
                            field: 'mailbox',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Mailbox" class='mail-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        // Explicitly updating related data fields as per your original logic
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'archiveMailbox',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Archive Mailbox" class='archivemail-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'onedrive',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Onedrive" class='onedrive-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'site',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Sharepoint" class='sharepoint-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'groupMailbox',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Group Mailbox" class='groupmail-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    disabled={!params.node.data || params.node.data.type !== "Office365"}
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'groupSite',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: { template: `<span title="Group Sharepoint" class='groupsite-icon'></span>` },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    disabled={!params.node.data || params.node.data.type !== "Office365"}
                                    checked={!!params.value}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, isChecked);
                                        params.node.data.selected = isChecked;
                                        params.node.data.members = isChecked;
                                    }}
                                />
                            )
                        }
                    ];
                    setColumnDefs(columnDefs);
                    break;
                }
            case 'site':
                {
                    let columnDefs = [
                        { field: 'name', headerName: 'Object', filter: false, width: 350 },
                        { field: 'itemType', headerName: 'Type', filter: false, width: 300 },
                        {
                            field: 'site',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Sharepoint" class='sharepoint-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    style={{ cursor: 'pointer' }}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, checked);
                                        // Syncing the legacy 'selected' property
                                        params.node.data.selected = checked;
                                    }}
                                />
                            )
                        }
                    ];
                    setColumnDefs(columnDefs);
                    break;
                }
            case 'team':
                {
                    var columnDefs = [
                        { field: 'displayName', headerName: 'Object', filter: false, width: 350 },
                        { field: 'itemType', headerName: 'Type', filter: false, width: 300 },
                        {
                            field: 'teams',
                            headerName: '',
                            flex: 1,
                            headerComponentParams: {
                                template: `<span title="Teams" class='teams-icon'></span>`
                            },
                            cellRenderer: (params) => (
                                <input
                                    type="checkbox"
                                    checked={!!params.value}
                                    style={{ cursor: 'pointer' }}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        params.node.setDataValue(params.column.colId, checked);
                                        params.node.data.selected = checked;
                                    }}
                                />
                            )
                        },
                        {
                            field: 'teamsChat',
                            headerName: '',
                            flex: 1,
                            hide: props.popupType === "ExcludeObjects",
                            headerComponentParams: {
                                template: `<span title="Teams Chat" class='teamsChat-icon'></span>`
                            },
                            cellRenderer: (params) => {
                                // Pre-calculating logic to match your original constraints
                                const isTeamsEnabled = params.node.data && params.node.data.teams;
                                const isAllowedByOrg = typeof appOrg !== 'undefined' && appOrg.isTeamsChatsOnline;
                                const isDisabled = !(isTeamsEnabled && isAllowedByOrg);

                                return (
                                    <input
                                        type="checkbox"
                                        disabled={isDisabled}
                                        // Checkbox is checked only if allowed AND value is true
                                        checked={!isDisabled && !!params.value}
                                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            params.node.setDataValue(params.column.colId, checked);
                                            params.node.data.selected = checked;
                                        }}
                                    />
                                );
                            }
                        }
                    ];
                    setColumnDefs(columnDefs);
                    break;
                }
            default:
                {
                    setColumnDefs([]);
                    break;
                }
        }
    }
    const onGridReady = (params) => {
        const loadData = async () => {
            let dataType;

            switch (props.itemType) {
                case 'user':
                    dataType = "users";
                    break;
                case 'team':
                    dataType = "teams";
                    break;
                case 'group':
                    dataType = "groups";
                    break;
                case 'site':
                    dataType = "sites";
                    break;
                default:
                    break;
            }

            params.api.setGridOption('datasource', {
                getRows: async (param) => {
                    console.log("Sort model:", param.sortModel);
                    console.log("Filter model:", param.filterModel);
                    const { startRow, endRow, successCallback, failCallback } = param;
                    if (params.api && (startRow === 0 || params.api.getDisplayedRowCount() === 0)) {
                        params.api.setGridOption("loading", true);
                        params.api.setGridOption('rowData', []);
                    }

                    try {
                        const data = await getAppContextData( dataType, startRow, endRow, params);
                        successCallback(data.rows, data.totalCount);
                    } catch (error) {
                        failCallback();
                    } finally {
                        if (params.api) {
                            params.api.setGridOption("loading", false);
                        }
                    }
                },
            });
        };

        loadData(); 
        setGridApi(params.api);
    };
    async function getAppContextData( attr, startRow, endRow, params) {
        if (!startRow) {
            startRow = 0;
        }
        const config = {
            headers: {
                Authorisation: `Bearer ` + appOrg.token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        var isloaded = false;
        if (startRow === 0) {
            setAppOrg((prev) => {
                return {
                    ...prev,
                    [attr]: {
                        isloaded: isloaded,
                        value: {}
                    }
                }
            });
        }
        
        ////let data = await Axios.post(API_ROUTE + Routes.GET_365_DATA, payload, config)
        ////    .then((response) => {
        ////        isloaded = true;
        ////        let result = JSON.parse(response.data);
        ////        return result.results;
        ////    })
        ////    .catch((reason) => {
        ////        // closeAlertModal(reason.message);
        ////        if (reason?.response?.status === 440) {
        ////            window.location.href = "/TimeoutErrorHandler";
        ////        }
        ////    });

        let data = await Axios.get(API_ROUTE + Routes.ORG_DATA(appOrg.orgId, attr, startRow) , config)
            .then((response) => {
                isloaded = true;
                let result = JSON.parse(response.data);
                return result.results;
            })
            .catch((reason) => {
                // closeAlertModal(reason.message);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });
        switch (attr) {
            case "users":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            itemType: "user",
                            selected: false,
                            excluded: false
                        }));
                    break;
                }
            case "groups":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            groupMailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            groupSite: false,
                            itemType: "group",
                            selected: false,
                            excluded: false
                        }));
                    break;
                }
            case "sites":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            site: false,
                            itemType: "site",
                            selected: false,
                            excluded: false
                        }));
                    break;
                }
            case "teams":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            teams: false,
                            teamsChat: false,
                            itemType: "team",
                            selected: false,
                            excluded: false
                        }));
                    break;
                }
            default:
                break;
        }
        let returnData = [];
        if (props.popupType === "AddObjects") {
            switch (props.itemType) {
                case "user": {

                    let userItems = filterExcludedObjects(data);

                    for (let i = 0; i < appOrg.selectedObjects.length; i++) {

                        let index = userItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                        if (userItems.find(x => x.id === appOrg.selectedObjects[i].id))
                            userItems[index] = appOrg.selectedObjects[i];
                    }
                    returnData = userItems;
                    //params.api.setRowData(userItems);
                    break;
                }
                case "group": {

                    let groupItems = filterExcludedObjects(data);

                    for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                        let index = groupItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                        if (groupItems.find(x => x.id === appOrg.selectedObjects[i].id))
                            groupItems[index] = appOrg.selectedObjects[i];
                    }
                    returnData = groupItems;
                    //params.api.setRowData(groupItems);
                    break;
                }
                case "site": {
                    let siteItems = filterExcludedObjects(data);

                    for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                        let index = siteItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                        if (siteItems.find(x => x.id === appOrg.selectedObjects[i].id))
                            siteItems[index] = appOrg.selectedObjects[i];
                    }
                    returnData = siteItems;
                    //params.api.setRowData(siteItems);
                    break;
                }
                case "team": {

                    let teamItems = filterExcludedObjects(data);

                    for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                        let index = teamItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                        if (teamItems.find(x => x.id === appOrg.selectedObjects[i].id))
                            teamItems[index] = appOrg.selectedObjects[i];
                    }
                    returnData = teamItems;
                    //params.api.setRowData(teamItems);
                    break;
                }

                default:
                    params.api.setGridOption('rowData', []);
            }
        }
        else if (props.popupType === "ExcludeObjects") {
            switch (props.itemType) {
                case "user": {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            itemType: "user",
                            selected: false,
                            excluded: false
                        }));
                    let userItems = filterIncludedObjects(data);

                    for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                        let index = userItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                        if (userItems.find(x => x.id === appOrg.excludedObjects[i].id))
                            userItems[index] = appOrg.excludedObjects[i];
                    }
                    returnData = userItems;
                    //params.api.setRowData(userItems);
                    break;
                }
                case "group": {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            groupMailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            groupSite: false,
                            itemType: "group",
                            selected: false,
                            excluded: false
                        }));
                    let groupItems = filterIncludedObjects(data);

                    for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                        let index = groupItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                        if (groupItems.find(x => x.id === appOrg.excludedObjects[i].id))
                            groupItems[index] = appOrg.excludedObjects[i];
                    }
                    returnData = groupItems;
                    //params.api.setRowData(groupItems);
                    break;
                }
                case "site": {
                    data = data.map((x) => (
                        {
                            ...x,
                            site: false,
                            itemType: "site",
                            selected: false,
                            excluded: false
                        }));
                    let siteItems = filterIncludedObjects(data);

                    for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                        let index = siteItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                        if (siteItems.find(x => x.id === appOrg.excludedObjects[i].id))
                            siteItems[index] = appOrg.excludedObjects[i];
                    }
                    returnData = siteItems;
                    //params.api.setRowData(siteItems);
                    break;
                }
                case "team": {
                    data = data.map((x) => (
                        {
                            ...x,
                            teams: false,
                            teamsChat: false,
                            itemType: "team",
                            selected: false,
                            excluded: false
                        }));
                    let teamItems = filterIncludedObjects(data);

                    for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                        let index = teamItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                        if (teamItems.find(x => x.id === appOrg.excludedObjects[i].id))
                            teamItems[index] = appOrg.excludedObjects[i];
                    }
                    returnData = teamItems;
                    //params.api.setRowData(teamItems);
                    break;
                }
                default:
                    params.api.setGridOption('rowData', []);
            }
        }
        if (startRow === 0) {
            setAppOrg((prev) => {
                return {
                    ...prev,
                    [attr]: {
                        value: returnData,
                        isloaded: isloaded
                    }
                }
            });
        }
        else {
            setAppOrg((prev) => {
                return {
                    ...prev,
                    [attr]: {
                        value: [...prev[attr]?.value || [], ...returnData],
                        isloaded: isloaded
                    }
                }
            });
        }
        
        setPopulate(p => !p);

        if (returnData.length < 100) {
            return {
                rows: returnData,
                totalCount: startRow + returnData.length
            };
        }
        else {
            return {
                rows: returnData,
                totalCount: endRow + returnData.length
            };
        }

    }
    //async function getAppContextData(link, attr, params) {

    //    const config = {
    //        headers: {
    //            Authorisation: `Bearer ` + appOrg.token,
    //            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
    //        },
    //    };
    //    let payload = {
    //        url: link,
    //        orgId: appOrg.orgId,
    //    };

    //    var isloaded = false;
    //    setAppOrg((prev) => {
    //        return {
    //            ...prev,
    //            [attr]: {
    //                isloaded: isloaded,
    //                value: {}
    //            }
    //        }
    //    });
    //    let data = await Axios.post(API_ROUTE + Routes.GET_DATA, payload, config)
    //        .then((response) => {
    //            isloaded = true;
    //            return JSON.parse(response.data);
    //        })
    //        .catch((reason) => {
    //            // closeAlertModal(reason.message);
    //            if (reason?.response?.status === 440) {
    //                window.location.href = "/TimeoutErrorHandler";
    //            }

    //        });
    //    switch (attr) {
    //        case "users":
    //            {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        mailbox: false,
    //                        archiveMailbox: false,
    //                        onedrive: false,
    //                        site: false,
    //                        itemType: "user",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                break;
    //            }
    //        case "groups":
    //            {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        mailbox: false,
    //                        groupMailbox: false,
    //                        archiveMailbox: false,
    //                        onedrive: false,
    //                        site: false,
    //                        groupSite: false,
    //                        itemType: "group",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                break;
    //            }
    //        case "sites":
    //            {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        site: false,
    //                        itemType: "site",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                break;
    //            }
    //        case "teams":
    //            {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        teams: false,
    //                        teamsChat: false,
    //                        itemType: "team",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                break;
    //            }
    //    }
    //    if (props.popupType === "AddObjects") {
    //        switch (props.itemType) {
    //            case "user": {

    //                let userItems = filterExcludedObjects(data);

    //                for (var i = 0; i < appOrg.selectedObjects.length; i++) {

    //                    let index = userItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
    //                    if (userItems.find(x => x.id === appOrg.selectedObjects[i].id))
    //                        userItems[index] = appOrg.selectedObjects[i];
    //                }
    //                params.api.setRowData(userItems);
    //                break;
    //            }
    //            case "group": {

    //                let groupItems = filterExcludedObjects(data);

    //                for (var i = 0; i < appOrg.selectedObjects.length; i++) {
    //                    let index = groupItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
    //                    if (groupItems.find(x => x.id === appOrg.selectedObjects[i].id))
    //                        groupItems[index] = appOrg.selectedObjects[i];
    //                }
    //                params.api.setRowData(groupItems);
    //                break;
    //            }
    //            case "site": {
    //                let siteItems = filterExcludedObjects(data);

    //                for (var i = 0; i < appOrg.selectedObjects.length; i++) {
    //                    let index = siteItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
    //                    if (siteItems.find(x => x.id === appOrg.selectedObjects[i].id))
    //                        siteItems[index] = appOrg.selectedObjects[i];
    //                }

    //                params.api.setRowData(siteItems);
    //                break;
    //            }
    //            case "team": {

    //                let teamItems = filterExcludedObjects(data);

    //                for (var i = 0; i < appOrg.selectedObjects.length; i++) {
    //                    let index = teamItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
    //                    if (teamItems.find(x => x.id === appOrg.selectedObjects[i].id))
    //                        teamItems[index] = appOrg.selectedObjects[i];
    //                }
    //                params.api.setRowData(teamItems);
    //                break;
    //            }

    //            default:
    //                params.api.setRowData([]);
    //        }
    //    }
    //    else if (props.popupType === "ExcludeObjects") {
    //        switch (props.itemType) {
    //            case "user": {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        mailbox: false,
    //                        archiveMailbox: false,
    //                        onedrive: false,
    //                        site: false,
    //                        itemType: "user",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                let userItems = filterIncludedObjects(data);

    //                for (var i = 0; i < appOrg.excludedObjects.length; i++) {
    //                    let index = userItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
    //                    if (userItems.find(x => x.id === appOrg.excludedObjects[i].id))
    //                        userItems[index] = appOrg.excludedObjects[i];
    //                }
    //                params.api.setRowData(userItems);
    //                break;
    //            }
    //            case "group": {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        mailbox: false,
    //                        groupMailbox: false,
    //                        archiveMailbox: false,
    //                        onedrive: false,
    //                        site: false,
    //                        groupSite: false,
    //                        itemType: "group",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                let groupItems = filterIncludedObjects(data);

    //                for (var i = 0; i < appOrg.excludedObjects.length; i++) {
    //                    let index = groupItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
    //                    if (groupItems.find(x => x.id === appOrg.excludedObjects[i].id))
    //                        groupItems[index] = appOrg.excludedObjects[i];
    //                }
    //                params.api.setRowData(groupItems);
    //                break;
    //            }
    //            case "site": {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        site: false,
    //                        itemType: "site",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                let siteItems = filterIncludedObjects(data);

    //                for (var i = 0; i < appOrg.excludedObjects.length; i++) {
    //                    let index = siteItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
    //                    if (siteItems.find(x => x.id === appOrg.excludedObjects[i].id))
    //                        siteItems[index] = appOrg.excludedObjects[i];
    //                }
    //                params.api.setRowData(siteItems);
    //                break;
    //            }
    //            case "team": {
    //                data = data.map((x) => (
    //                    {
    //                        ...x,
    //                        teams: false,
    //                        teamsChat: false,
    //                        itemType: "team",
    //                        selected: false,
    //                        excluded: false
    //                    }));
    //                let teamItems = filterIncludedObjects(data);

    //                for (var i = 0; i < appOrg.excludedObjects.length; i++) {
    //                    let index = teamItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
    //                    if (teamItems.find(x => x.id === appOrg.excludedObjects[i].id))
    //                        teamItems[index] = appOrg.excludedObjects[i];
    //                }
    //                params.api.setRowData(teamItems);
    //                break;
    //            }
    //            default:
    //                params.api.setRowData([]);
    //        }
    //    }

    //    setAppOrg((prev) => {
    //        return {
    //            ...prev,
    //            [attr]: {
    //                value: data,
    //                isloaded: isloaded
    //            }
    //        }
    //    });
    //    setPopulate(p => !p);


    //}


    function populateGrid(params) {
        if (params?.api) {
            if (props.popupType === "AddObjects") {
                switch (props.itemType) {
                    case "user": {

                        let userItems = filterExcludedObjects(appOrg.users.value);

                        for (let i = 0; i < appOrg.selectedObjects.length; i++) {

                            let index = userItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                            if (userItems.find(x => x.id === appOrg.selectedObjects[i].id))
                                userItems[index] = appOrg.selectedObjects[i];
                        }
                        params.api.setGridOption('rowData', userItems);
                        break;
                    }
                    case "group": {

                        let groupItems = filterExcludedObjects(appOrg.groups.value);

                        for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                            let index = groupItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                            if (groupItems.find(x => x.id === appOrg.selectedObjects[i].id))
                                groupItems[index] = appOrg.selectedObjects[i];
                        }
                        params.api.setGridOption('rowData', groupItems);
                        break;
                    }
                    case "site": {

                        let siteItems = filterExcludedObjects(appOrg.sites.value);

                        for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                            let index = siteItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                            if (siteItems.find(x => x.id === appOrg.selectedObjects[i].id))
                                siteItems[index] = appOrg.selectedObjects[i];
                        }
                        params.api.setGridOption('rowData', siteItems);
                        break;
                    }
                    case "team": {

                        let teamItems = filterExcludedObjects(appOrg.teams.value);

                        for (let i = 0; i < appOrg.selectedObjects.length; i++) {
                            let index = teamItems.findIndex(x => x.id === appOrg.selectedObjects[i].id)
                            if (teamItems.find(x => x.id === appOrg.selectedObjects[i].id))
                                teamItems[index] = appOrg.selectedObjects[i];
                        }
                        params.api.setGridOption('rowData', teamItems);
                        break;
                    }

                    default:
                        params.api.setGridOption('rowData', []);
                }
            }
            else if (props.popupType === "ExcludeObjects") {
                switch (props.itemType) {
                    case "user": {
                        appOrg.users.value = appOrg.users.value.map((x) => (
                            {
                                ...x,
                                mailbox: false,
                                archiveMailbox: false,
                                onedrive: false,
                                site: false,
                                itemType: "user",
                                selected: false,
                                excluded: false
                            }));
                        let userItems = filterIncludedObjects(appOrg.users.value);

                        for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                            let index = userItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                            if (userItems.find(x => x.id === appOrg.excludedObjects[i].id))
                                userItems[index] = appOrg.excludedObjects[i];
                        }
                        params.api.setGridOption('rowData', userItems);
                        break;
                    }
                    case "group": {
                        appOrg.groups.value = appOrg.groups.value.map((x) => (
                            {
                                ...x,
                                mailbox: false,
                                groupMailbox: false,
                                archiveMailbox: false,
                                onedrive: false,
                                site: false,
                                groupSite: false,
                                itemType: "group",
                                selected: false,
                                excluded: false
                            }));
                        let groupItems = filterIncludedObjects(appOrg.groups.value);

                        for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                            let index = groupItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                            if (groupItems.find(x => x.id === appOrg.excludedObjects[i].id))
                                groupItems[index] = appOrg.excludedObjects[i];
                        }
                        params.api.setGridOption('rowData', groupItems);
                        break;
                    }
                    case "site": {
                        appOrg.sites.value = appOrg.sites.value.map((x) => (
                            {
                                ...x,
                                site: false,
                                itemType: "site",
                                selected: false,
                                excluded: false
                            }));
                        let siteItems = filterIncludedObjects(appOrg.sites.value);

                        for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                            let index = siteItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                            if (siteItems.find(x => x.id === appOrg.excludedObjects[i].id))
                                siteItems[index] = appOrg.excludedObjects[i];
                        }
                        params.api.setGridOption('rowData', siteItems);
                        break;
                    }
                    case "team": {
                        appOrg.teams.value = appOrg.teams.value.map((x) => (
                            {
                                ...x,
                                teams: false,
                                teamsChat: false,
                                itemType: "team",
                                selected: false,
                                excluded: false
                            }));
                        let teamItems = filterIncludedObjects(appOrg.teams.value);

                        for (let i = 0; i < appOrg.excludedObjects.length; i++) {
                            let index = teamItems.findIndex(x => x.id === appOrg.excludedObjects[i].id)
                            if (teamItems.find(x => x.id === appOrg.excludedObjects[i].id))
                                teamItems[index] = appOrg.excludedObjects[i];
                        }
                        params.api.setGridOption('rowData', teamItems);
                        break;
                    }
                    default:
                        params.api.setGridOption('rowData', []);
                }
            }
            //setGridApi(params.api);
        }

    }


    function filterExcludedObjects(objects) {
        if (appOrg.excludedObjects.length > 0) {
            for (var i = 0; i < appOrg.excludedObjects.length; i++) {
                let excludedObjectid = appOrg.excludedObjects[i].id
                objects = objects.filter(item => item.id !== excludedObjectid);
            }
                
        }
        return objects;
    }

    const filterIncludedObjects = (params) => {
        if (appOrg.selectedObjects.length > 0) {
            for (var i = 0; i < appOrg.selectedObjects.length; i++) {
                let selectedObjectid = appOrg.selectedObjects[i].id
                params = params.filter(item => item.id !== selectedObjectid);
            }
                
        }
        return params;
    }

    function UpdateUser(e) {
        if (props.popupType === "AddObjects") {
            let selectedRow = [];
            gridRef.current.api.forEachNode(node => {
                if (node.data.selected ||
                    node.data.mailbox ||
                    node.data.archiveMailbox ||
                    node.data.site ||
                    node.data.onedrive ||
                    node.data.groupMailbox ||
                    node.data.groupSite ||
                    node.data.teams ||
                    node.data.teamsChat) {
                    switch (node.data.itemType) {
                        case "user":
                            {
                                let index = appOrg.users.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.users.value[index].mailbox = node.data.mailbox === undefined ? false : node.data.mailbox;
                                    appOrg.users.value[index].archiveMailbox = node.data.archiveMailbox === undefined ? false : node.data.archiveMailbox;
                                    appOrg.users.value[index].site = node.data.site === undefined ? false : node.data.site;
                                    appOrg.users.value[index].onedrive = node.data.onedrive === undefined ? false : node.data.onedrive;
                                    appOrg.users.value[index].selected = node.data.selected;
                                    selectedRow.push(appOrg.users.value[index]);
                                }
                                break;
                            }
                        case "group":
                            {
                                
                                let index = appOrg.groups.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.groups.value[index].mailbox = node.data.mailbox === undefined ? false : node.data.mailbox;
                                    appOrg.groups.value[index].archiveMailbox = node.data.archiveMailbox === undefined ? false : node.data.archiveMailbox;
                                    appOrg.groups.value[index].site = node.data.site === undefined ? false : node.data.site;
                                    appOrg.groups.value[index].onedrive = node.data.onedrive === undefined ? false : node.data.onedrive;
                                    appOrg.groups.value[index].groupMailbox = node.data.groupMailbox === undefined ? false : node.data.groupMailbox;
                                    appOrg.groups.value[index].groupSite = node.data.groupSite === undefined ? false : node.data.groupSite;
                                    appOrg.groups.value[index].selected = node.data.selected;
                                    selectedRow.push(appOrg.groups.value[index]);
                                }
                                break;
                            }
                        case "site":
                            {
                                
                                let index = appOrg.sites.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.sites.value[index].site = node.data.site === undefined ? false : node.data.site;
                                    appOrg.sites.value[index].selected = node.data.selected;
                                    appOrg.sites.value[index].displayName = node.data.title;
                                    selectedRow.push(appOrg.sites.value[index]);
                                }
                                break;
                            }
                        case "team":
                            {
                                
                                let index = appOrg.teams.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.teams.value[index].teams = node.data.teams === undefined ? false : node.data.teams;
                                    appOrg.teams.value[index].teamsChat = node.data.teamsChat === undefined ? false : node.data.teamsChat;
                                    appOrg.teams.value[index].selected = node.data.selected;
                                    appOrg.teams.value[index].name = node.data.description;
                                    selectedRow.push(appOrg.teams.value[index]);
                                }
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                }
            });
            appOrg.selectedObjects = appOrg.selectedObjects.filter(function (obj) {
                return obj.itemType !== props.itemType;
            });

            appOrg.selectedObjects.push(...selectedRow);
        }
        else if (props.popupType === "ExcludeObjects") {
            let selectedRow = [];
            gridRef.current.api.forEachNode(node => {
                if (node.data.selected ||
                    node.data.mailbox ||
                    node.data.archiveMailbox ||
                    node.data.site ||
                    node.data.onedrive ||
                    node.data.groupMailbox ||
                    node.data.groupSite ||
                    node.data.teams ||
                    node.data.teamsChat) {
                    switch (node.data.itemType) {
                        case "user":
                            {
                                let index = appOrg.users.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.users.value[index].mailbox = node.data.mailbox;
                                    appOrg.users.value[index].archiveMailbox = node.data.archiveMailbox;
                                    appOrg.users.value[index].site = node.data.site;
                                    appOrg.users.value[index].onedrive = node.data.onedrive;
                                    appOrg.users.value[index].excluded = node.data.selected;
                                    appOrg.users.value[index].selected = false;
                                    selectedRow.push(node.data);
                                }
                                break;
                            }
                        case "group":
                            {
                                let index = appOrg.groups.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.groups.value[index].mailbox = node.data.mailbox;
                                    appOrg.groups.value[index].archiveMailbox = node.data.archiveMailbox;
                                    appOrg.groups.value[index].site = node.data.site;
                                    appOrg.groups.value[index].onedrive = node.data.onedrive;
                                    appOrg.groups.value[index].groupMailbox = node.data.groupMailbox;
                                    appOrg.groups.value[index].groupSite = node.data.groupSite;
                                    appOrg.groups.value[index].excluded = node.data.selected;
                                    appOrg.groups.value[index].selected = false;
                                    selectedRow.push(node.data);
                                }
                                break;
                            }
                        case "site":
                            {
                                let index = appOrg.sites.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.sites.value[index].site = node.data.site;
                                    appOrg.sites.value[index].excluded = node.data.selected;
                                    appOrg.sites.value[index].displayName = node.data.title;
                                    appOrg.sites.value[index].selected = false;
                                    selectedRow.push(node.data);
                                }
                                break;
                            }
                        case "team":
                            {
                                let index = appOrg.teams.value.findIndex(item => item.id === node.data.id);
                                if (index > -1) {
                                    appOrg.teams.value[index].teams = node.data.teams;
                                    appOrg.teams.value[index].excluded = node.data.selected;
                                    appOrg.teams.value[index].name = node.data.description;
                                    appOrg.teams.value[index].selected = false;
                                    selectedRow.push(node.data);
                                }
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                }
            });
            appOrg.excludedObjects = appOrg.excludedObjects.filter(function (obj) {
                return obj.itemType !== props.itemType;
            });
            appOrg.excludedObjects.push(...selectedRow);
        }
        closeModal(e);
    }

    function closeModal(e) {
        appOrg.rowData = [];
        e.stopPropagation();
        clearData();
        props.closeModal(true);
    }

    const clearData = () => {
        switch (props.itemType) {
            case "user": {
                const users = Array.isArray(appOrg?.users?.value) ? appOrg.users.value : [];
                appOrg.users.value = users.map(x => ({
                    ...x,
                    mailbox: false,
                    archiveMailbox: false,
                    onedrive: false,
                    site: false,
                    itemType: "user",
                    selected: false,
                    excluded: false
                }));
                break;
            }

            case "group": {
                const groups = Array.isArray(appOrg?.groups?.value) ? appOrg.groups.value : [];
                appOrg.groups.value = groups.map(x => ({
                    ...x,
                    mailbox: false,
                    groupMailbox: false,
                    archiveMailbox: false,
                    onedrive: false,
                    site: false,
                    groupSite: false,
                    itemType: "group",
                    selected: false,
                    excluded: false
                }));
                break;
            }

            case "site": {
                const sites = Array.isArray(appOrg?.sites?.value) ? appOrg.sites.value : [];
                appOrg.sites.value = sites.map(x => ({
                    ...x,
                    site: false,
                    itemType: "site",
                    selected: false,
                    excluded: false
                }));
                break;
            }

            case "team": {
                const teams = Array.isArray(appOrg?.teams?.value) ? appOrg.teams.value : [];
                appOrg.teams.value = teams.map(x => ({
                    ...x,
                    teams: false,
                    teamsChat: false,
                    itemType: "team",
                    selected: false,
                    excluded: false
                }));
                break;
            }
            default:
                break;
        }
        gridRef.current.api.setGridOption('rowData', []);
    };

    useEffect(() => {
    }, [props.itemType, props.popupType]);
    useEffect(() => {
        populateGrid(gridApi);
    }, [populate]);

    

    useEffect(() => {
        setColumnDefinition();
    }, [props.refresh]);

    return (
        <div>
            <div
                style={divStyle}
                className="modal fade show"
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl">
                    <div className="modal-content" style={{ width: "1000px", position: "absolute", left: "6%" }}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {props.popupType === "ExcludeObjects"? "Exclude Objects" : "Add Objects"}
                            </h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body" style={{ height: "400px", minWidth: "100%", width: "inherit" }}>
                            <div className="ag-theme-alpine" id="add_exclude_aggrid"  style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "100%", height: "100%", borderCollapse: "collapse" }} >
                                {/*<input type="search" placeholder="search..." value={searchTerm} onChange={onFilterTextChange} className="form-control form-control-sm" />*/}
                                {
                                    props.refresh &&
                                        (
                                        <AgGridReact style={{ width: "80%" }}
                                                
                                            ref={gridRef}
                                            getRowStyle={getRowStyle}
                                            headerHeight={headerHeight}
                                            defaultColDef={defaultColDef}
                                            rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                                            enableCellTextSelection={true}
                                            onGridReady={onGridReady}
                                            columnDefs={columnDefs}
                                            animateRows={true}
                                            overlayLoadingTemplate={
                                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                            overlayNoRowsTemplate={
                                                '<span className="ag-overlay-loading-center">No records to show</span>'
                                            }
                                            rowHeight={rowHeight}
                                            rowModelType="infinite"
                                            paginationPageSizeSelector={[20, 50, 100, 100]}
                                            >
                                            </AgGridReact>
                                        )
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            {/*<div align="left">*/}
                            {/*    <label>*/}
                            {/*        <span>Select All</span>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            {/*<Switch onChange={selectAll} checked={allChecked} onColor={"#0069d9"} />*/}
                            <button onClick={UpdateUser} type="submit" className="btn btn-primary btn-sm">
                                Update
                            </button>
                            <button onClick={closeModal} className="btn btn-secondary btn-sm">
                                Cancel
                            </button>
                        </ div>
                    </div>
                </div>
            </div>
            <div data-act-control-type="modalPopupBackground" id="HelpModal_backgroundElement" className="Background" style={{ display: props.displayModal ? "block" : "none", backgroundColor: "black", opacity: "0.8", position: "fixed", left: "0px", top: "0px", zIndex: "10000", width: "100%", height: "100%" }} />
        </div>
    );
};

export default PopupModal;
